export const debriefWizardFlow = {
    id: 'debrief-wizard',
    title: 'wizard:debriefQuestions.title',
    description: 'wizard:debriefQuestions.description',
    firstStepId: 'debrief-type',
    steps: [
        {
            id: 'debrief-type',
            title: 'wizard:debriefQuestions.type.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'personal',
                                title: 'wizard:debriefQuestions.type.personal',
                            },
                            {
                                id: 'group',
                                title: 'wizard:debriefQuestions.type.group',
                            },
                        ],
                    },
                },
            },
            nextStep: (answer) => {
                if (answer[0] === 'personal') {
                    return 'debrief-expected-result';
                }
                return 'debrief-core-participants';
            },
        },
        {
            id: 'debrief-core-participants',
            title: 'wizard:debriefQuestions.debriefCrucialParticipants.title',
            component: {
                id: 'MultiEmployeeSelection',
                props: {
                    options: {
                        type: 'fetch',
                        data: 'fetch-employees',
                    },
                    multiSelect: {
                        type: 'static',
                        data: true,
                    },
                    placeholder: {
                        type: 'static',
                        data: 'wizard:questions.firstQuestion.placeholder',
                    },
                },
            },
            nextStep: 'debrief-expected-result',
        },
        // {
        //   id: 'debrief-other-participants',
        //   title: 'wizard:debriefQuestions.debriefNonCrucialParticipants.title',
        //   component: {
        //     id: 'MultiEmployeeSelection',
        //     props: {
        //       options: {
        //         type: 'fetch',
        //         data: 'fetch-employees',
        //       },
        //       multiSelect: {
        //         type: 'static',
        //         data: true,
        //       },
        //       placeholder: {
        //         type: 'static',
        //         data: 'wizard:questions.firstQuestion.placeholder',
        //       },
        //     },
        //   },
        //   skipable: true,
        //   nextStep: 'debrief-viewers',
        // },
        {
            id: 'debrief-expected-result',
            title: 'wizard:debriefQuestions.expectedResult.title',
            component: {
                id: 'TextAreaChoice',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                title: 'wizard:debriefQuestions.expectedResult.achievedResult.title',
                                id: 'achieved-results',
                                icon: '✅',
                            },
                            {
                                title: 'wizard:debriefQuestions.expectedResult.notAchievedResult.title',
                                id: 'not-achieved-results',
                                icon: '⚠️',
                            },
                        ],
                    },
                    textAreaLabel: {
                        type: 'static',
                        data: 'wizard:debriefQuestions.expectedResult.textAreaLabel',
                    },
                    textAreaRequired: {
                        type: 'static',
                        data: true,
                    },
                    choiceRequired: {
                        type: 'static',
                        data: true,
                    },
                },
            },
            nextStep: 'debrief-goal-selection',
        },
        {
            id: 'debrief-goal-selection',
            title: 'wizard:debriefQuestions.debriefGoalSelection.title',
            component: {
                id: 'GoalsChoice',
                props: {
                    options: {
                        type: 'fetch',
                        data: 'fetch-goals',
                    },
                },
            },
            nextStep: 'debrief-facts',
        },
        {
            id: 'debrief-facts',
            title: 'wizard:debriefQuestions.facts.title',
            description: 'wizard:debriefQuestions.facts.description',
            component: {
                id: 'FactsList',
                props: {
                    minFacts: {
                        type: 'static',
                        data: 1,
                    },
                },
            },
            nextStep: 'debrief-top-facts',
        },
        {
            id: 'debrief-top-facts',
            title: 'wizard:debriefQuestions.topFacts.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'previous-answer',
                        data: {
                            answersStepId: 'debrief-facts',
                            titleField: 'text',
                            idField: 'id',
                        },
                    },
                    columns: {
                        type: 'static',
                        data: 3,
                    },
                    multiSelect: {
                        type: 'static',
                        data: true,
                    },
                    maxItems: {
                        type: 'static',
                        data: 3,
                    },
                },
            },
            nextStep: 'debrief-match-point-0-what-actions', // Will be dynamically generated
        },
    ],
    dynamicSteps: [
        {
            afterStepId: 'debrief-top-facts',
            answersStepId: 'debrief-top-facts',
            generateSteps: (answers) => {
                // const selectedFacts = answers['debrief-top-facts']?.map((fact: { id: string; text: string }) => fact.text);
                const selectedFacts = answers['debrief-facts']?.filter((fact) => answers?.['debrief-top-facts']?.includes(fact.id));
                if (!selectedFacts || selectedFacts.length === 0) {
                    return [];
                }
                const steps = [];
                selectedFacts.forEach((fact, index) => {
                    const groupId = `match-point-${index}`;
                    // Step 1: Sequential choice - I Did/Didn't + Actions
                    steps.push({
                        id: `debrief-match-point-${index}-what-actions`,
                        title: 'wizard:debriefQuestions.matchPoint.whatDidYouDo.title',
                        bot: {
                            groupTitle: fact.text, // Use fact text as the group title
                            group: groupId,
                        },
                        component: {
                            id: 'ChatbotChoice',
                            props: {
                                choices: {
                                    type: 'static',
                                    data: [
                                        {
                                            options: {
                                                type: 'static',
                                                data: [
                                                    {
                                                        id: 'i-did',
                                                        title: 'wizard:debriefQuestions.matchPoint.whatDidYouDo.iDid',
                                                    },
                                                    {
                                                        id: 'i-didnt',
                                                        title: 'wizard:debriefQuestions.matchPoint.whatDidYouDo.iDidnt',
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            question: 'wizard:debriefQuestions.matchPoint.actions.title',
                                            options: {
                                                type: 'static',
                                                data: [
                                                    {
                                                        id: 'set-clear-goals',
                                                        title: 'wizard:debriefQuestions.matchPoint.actions.setClearGoals',
                                                    },
                                                    {
                                                        id: 'define-responsible-person',
                                                        title: 'wizard:debriefQuestions.matchPoint.actions.defineResponsiblePerson',
                                                    },
                                                    {
                                                        id: 'perform-preparation',
                                                        title: 'wizard:debriefQuestions.matchPoint.actions.performPreparation',
                                                    },
                                                    {
                                                        id: 'shared-information',
                                                        title: 'wizard:debriefQuestions.matchPoint.actions.sharedInformation',
                                                    },
                                                    {
                                                        id: 'act-in-response-to-interaction',
                                                        title: 'wizard:debriefQuestions.matchPoint.actions.actInResponseToInteraction',
                                                    },
                                                    {
                                                        id: 'work-according-to-procedure',
                                                        title: 'wizard:debriefQuestions.matchPoint.actions.workAccordingToProcedure',
                                                    },
                                                    {
                                                        id: 'matching-expectations',
                                                        title: 'wizard:debriefQuestions.matchPoint.actions.matchingExpectations',
                                                    },
                                                    {
                                                        id: 'improvisation',
                                                        title: 'wizard:debriefQuestions.matchPoint.actions.improvisation',
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        },
                        nextStep: `debrief-match-point-${index}-why`,
                    });
                    steps.push({
                        id: `debrief-match-point-${index}-why`,
                        title: 'wizard:debriefQuestions.matchPoint.why.title',
                        bot: {
                            groupTitle: fact.text, // Use fact text as the group title
                            group: groupId,
                        },
                        component: {
                            id: 'ChatbotText',
                            props: {
                                showSkipOption: {
                                    type: 'static',
                                    data: true,
                                },
                                skipText: {
                                    type: 'static',
                                    data: 'wizard:debriefQuestions.matchPoint.why.skipText',
                                },
                            },
                        },
                        nextStep: (answer) => {
                            if (answer) {
                                return `debrief-match-point-${index}-reason`;
                            }
                            return `debrief-match-point-${index}-assumption`;
                        },
                    });
                    steps.push({
                        id: `debrief-match-point-${index}-reason`,
                        title: 'wizard:debriefQuestions.matchPoint.reason.title',
                        bot: {
                            groupTitle: fact.text, // Use fact text as the group title
                            group: groupId,
                        },
                        component: {
                            id: 'ChatbotText',
                            props: {},
                        },
                        nextStep: `debrief-match-point-${index}-assumption`,
                    });
                    steps.push({
                        id: `debrief-match-point-${index}-assumption`,
                        title: 'wizard:debriefQuestions.matchPoint.assumption.title',
                        bot: {
                            groupTitle: fact.text, // Use fact text as the group title
                            group: groupId,
                        },
                        component: {
                            id: 'ChatbotText',
                            props: {},
                        },
                        nextStep: `debrief-match-point-${index}-signal`,
                    });
                    steps.push({
                        id: `debrief-match-point-${index}-signal`,
                        title: 'wizard:debriefQuestions.matchPoint.signal.title',
                        bot: {
                            groupTitle: fact.text, // Use fact text as the group title
                            group: groupId,
                        },
                        component: {
                            id: 'WizardChatbotSignals',
                            props: {
                                placeholder: {
                                    type: 'static',
                                    data: 'wizard:debriefQuestions.matchPoint.signal.placeholder',
                                },
                                addMoreText: {
                                    type: 'static',
                                    data: 'wizard:debriefQuestions.matchPoint.signal.addMore',
                                },
                                continueText: {
                                    type: 'static',
                                    data: index === selectedFacts.length - 1
                                        ? 'wizard:debriefQuestions.matchPoint.signal.finish'
                                        : 'wizard:debriefQuestions.matchPoint.signal.continue',
                                },
                                minEntries: {
                                    type: 'static',
                                    data: 1,
                                },
                            },
                        },
                        nextStep: index < selectedFacts.length - 1
                            ? `debrief-match-point-${index + 1}-what-actions`
                            : undefined,
                    });
                });
                return steps;
            },
        },
    ],
};
